import APIClient from '@/shared/http/clients/api'

const resourceName = 'gedpasta'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}`, data, config)
const GetAllByFolder = (folderID, deleted, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${folderID}`, data, config)
const Get = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const UpdatePropagate = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/propagar`, data, config)
const UpdateFavor = (id, favor, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/favorito/${id}/${favor}`, data, config)
const PatchParentFolder = (id, data = {}, config = {}) => APIClient.patch(`${APIBusinessCommon}/${resourceName}/${id}/pastapai`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, data, config)
const GetStruct = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/pasta/${id}/estrutura`, data, config)
const CreateStruct = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/pasta/${id}/estrutura`, data, config)
const Download = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/download/${id}`, data, config)
const DownloadFile = (fileName) => APIClient.get(`${APIBusinessCommon}/${resourceName}/downloadFile/${fileName}`, {responseType: 'blob'})

const GedFolderRepository = {
  GetAll,
  GetAllByFolder,
  Get,
  Create,
  Update,
  UpdatePropagate,
  UpdateFavor,
  PatchParentFolder,
  Delete,
  GetStruct,
  CreateStruct,
  Download,
  DownloadFile
}

export default GedFolderRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/gedfolder.js